import { Component, OnDestroy } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { SignupPreviousPath } from '../../../enum/landing-enum'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'flowaccount-functions-for-accounting',
  templateUrl: './functions-for-accounting.component.html',
})
export class FunctionsForAccountingComponent implements OnDestroy {
  public customHeader = {
    heading: 'BLOG_SWIPER_TOPIC.HEADING_ACCOUNTING',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_ACCOUNTING',
  }
  public reviewSectionTextListAccounting = {
    title: 'REVIEWS_PARTNERS_FLOWACCOUNT.ACCOUNTING.TITLE',
    detail: 'REVIEWS_PARTNERS_FLOWACCOUNT.ACCOUNTING.DETAIL',
    button: 'REVIEWS_PARTNERS_FLOWACCOUNT.ACCOUNTING.BTN',
  }
  public signupPreviousPath = SignupPreviousPath
  protected langChangeSubscription: Subscription

  constructor(public translate: TranslateService, private seoService: SEOService, private titleService: Title) {
    this.langChangeSubscription = translate.onLangChange.subscribe(() => {
      this.setMeta()
    })
  }

  setMeta() {
    this.titleService.setTitle(this.translate.instant('metatitle-Function-accounting'))
    this.seoService.createMetaTag(
      this.translate.instant('metatitle-Function-accounting'),
      this.translate.instant('metaDescription-accounting'),
    )
    this.seoService.createOg(
      'https://flowaccountcdn.com/images/Thumnail_FlowPayroll_FlowAccount.png',
      this.translate.instant('metatitle-Function-accounting'),
      this.translate.instant('metaDescription-accounting'),
    )
  }

  ngOnDestroy() {
    this.langChangeSubscription.unsubscribe()
  }
}
